import { Card, Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import '../MainPages.css';

export default function SIC() {
    return (
        <Row>
            <Col xs="12">
                <p><small>Você está em SISTEMA DE INFORMAÇÃO AO CIDADÃO E OUVIDORIA</small></p>
            </Col>
            <Col xs="12">
                <h1>SISTEMA DE INFORMAÇÃO AO CIDADÃO E OUVIDORIA</h1>
                <h3>Consulte:</h3>
            </Col>
            <Col xs="12">
                <Link to="/ouvidoria/nova-soliticacao">
                    <Card style={{ width: '100%' }}>
                        <Card.Body style={{ display: 'flex', alignItems: 'center' }}>
                            <i style={{ fontSize: '60%', paddingRight: '10px' }} className="fa-solid fa-chevron-right"></i>
                            Nova Solicitação
                        </Card.Body>
                    </Card>
                </Link>
            </Col>
            <Col xs="12">
                <Link to="/ouvidoria/acompanhamento">
                    <Card style={{ width: '100%' }}>
                        <Card.Body style={{ display: 'flex', alignItems: 'center' }}>
                            <i style={{ fontSize: '60%', paddingRight: '10px' }} className="fa-solid fa-chevron-right"></i>
                            Acompanhamento
                        </Card.Body>
                    </Card>
                </Link>
            </Col>
            <Col xs="12">
                <Link to="/ouvidoria/relatorios">
                    <Card style={{ width: '100%' }}>
                        <Card.Body style={{ display: 'flex', alignItems: 'center' }}>
                            <i style={{ fontSize: '60%', paddingRight: '10px' }} className="fa-solid fa-chevron-right"></i>
                            Ouvidoria
                        </Card.Body>
                    </Card>
                </Link>
            </Col>
            <Col xs="12">
                <Link to="/ouvidoria/lgpd-alepe">
                    <Card style={{ width: '100%' }}>
                        <Card.Body style={{ display: 'flex', alignItems: 'center' }}>
                            <i style={{ fontSize: '60%', paddingRight: '10px' }} className="fa-solid fa-chevron-right"></i>
                            LGPD na Alepe
                        </Card.Body>
                    </Card>
                </Link>
            </Col>
        </Row>
    );
}
